import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/* The TabService class is an Injectable service that contains a BehaviorSubject for tracking the
selected input. */
@Injectable()
export class TabService {
  selectedInput: BehaviorSubject<number> = new BehaviorSubject<number>(1);
}